import Vue from 'vue'
import VueLocalStorage from 'vue-ls'

const options = {
  namespace: 'ihn_dm_'
}

Vue.use(VueLocalStorage, options)



// WEBPACK FOOTER //
// ./src/plugins/localstorage.js